/* NIVIÈREE — ADD TO BAG: FLY TO BAG V1 (22-10-2026)
   Loaded on every page. After a successful add the bag never opens by itself:
   a thumbnail of the product flies up into the header bag icon, which then gives a small bump.
   Uses the theme's own switch (variant:add -> detail.blockCartDrawerOpening). */
(() => {
  if (window.NiviereeFlyToBagReady) return;
  window.NiviereeFlyToBagReady = true;

  let lastTrigger = null;

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const remember = (element) => { lastTrigger = { element, at: Date.now() }; };

  document.addEventListener('submit', (event) => {
    if (event.target.matches?.('form[action*="/cart/add"]')) remember(event.target);
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('button[type="submit"], .nivieree-sticky-buy__btn, .product-card button, [class*="product-card"] button');
    if (button) remember(button);
  }, true);

  function isVisible(element) {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 20 && rect.height > 20 && rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function findSource(trigger) {
    const candidates = [];
    const card = trigger?.closest('.product-card, [class*="product-card"]');

    if (trigger?.closest('.nivieree-sticky-buy')) candidates.push(document.querySelector('.nivieree-sticky-buy__thumb'));
    if (card) candidates.push(...card.querySelectorAll('img'));

    candidates.push(...document.querySelectorAll(
      '.shopify-section--main-product .product-gallery__media.is-selected img, .shopify-section--main-product .product-gallery__media:not([hidden]) img'
    ));

    /* quick buy drawer / popover opened from a card */
    candidates.push(...document.querySelectorAll('quick-buy-drawer[open] img, quick-buy-popover[open] img, .quick-buy-drawer[open] img'));

    const visible = candidates.find((img) => img && isVisible(img));
    if (visible) return { src: visible.currentSrc || visible.src, rect: visible.getBoundingClientRect() };

    const anyImage = candidates.find((img) => img && (img.currentSrc || img.src));
    if (anyImage && trigger && isVisible(trigger)) {
      return { src: anyImage.currentSrc || anyImage.src, rect: trigger.getBoundingClientRect(), fromButton: true };
    }

    return null;
  }

  function findBagIcon() {
    const links = [...document.querySelectorAll(
      '.header a[aria-controls="cart-drawer"], a.nivieree-cart-link, .header a[href$="/cart"]'
    )];
    return links.find((link) => {
      const rect = link.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }) || null;
  }

  function bump(target) {
    if (!target || prefersReducedMotion()) return;

    target.animate(
      [
        { transform: 'scale(1)' },
        { transform: 'scale(1.28)', offset: 0.35 },
        { transform: 'scale(0.94)', offset: 0.7 },
        { transform: 'scale(1)' }
      ],
      { duration: 460, easing: 'ease-out' }
    );

    target.querySelector('cart-count, .count-bubble')?.animate(
      [
        { transform: 'scale(1)' },
        { transform: 'scale(1.45)', offset: 0.4 },
        { transform: 'scale(1)' }
      ],
      { duration: 420, delay: 80, easing: 'ease-out' }
    );
  }

  function fly(source, target) {
    const targetRect = target?.getBoundingClientRect();
    const endX = targetRect ? targetRect.left + targetRect.width / 2 : window.innerWidth - 32;
    const endY = targetRect && targetRect.bottom > 0 ? targetRect.top + targetRect.height / 2 : 28;

    const rect = source.rect;
    const base = source.fromButton ? 72 : Math.min(rect.width, rect.height) * 0.55;
    const size = Math.round(Math.min(Math.max(base, 72), 180));
    const startX = rect.left + rect.width / 2;
    const startY = rect.top + rect.height / 2;

    const outer = document.createElement('div');
    const inner = document.createElement('div');
    const image = new Image();

    outer.setAttribute('aria-hidden', 'true');
    outer.style.cssText = 'position:fixed;left:0;top:0;z-index:2147483000;pointer-events:none;will-change:transform;';
    inner.style.cssText = `width:${size}px;height:${size}px;will-change:transform,opacity;transform-origin:50% 50%;`;
    image.src = source.src;
    image.alt = '';
    image.style.cssText = 'display:block;width:100%;height:100%;object-fit:contain;background:#f3f3f1;border:1px solid rgb(17 17 17 / 0.08);box-shadow:0 14px 34px rgb(0 0 0 / 0.18);';

    inner.appendChild(image);
    outer.appendChild(inner);
    document.body.appendChild(outer);

    const half = size / 2;
    const duration = 820;

    /* X eases in and Y eases out, so the piece rises first and then curves into the bag */
    outer.animate(
      [
        { transform: `translateX(${startX - half}px)` },
        { transform: `translateX(${endX - half}px)` }
      ],
      { duration, easing: 'cubic-bezier(0.55, 0, 0.75, 0.6)', fill: 'forwards' }
    );

    const travel = inner.animate(
      [
        { transform: `translateY(${startY - half}px) scale(1)`, opacity: 1 },
        { transform: `translateY(${startY - half - 26}px) scale(1.05)`, opacity: 1, offset: 0.16 },
        { transform: `translateY(${endY - half}px) scale(0.14)`, opacity: 0.25 }
      ],
      { duration, easing: 'cubic-bezier(0.3, 0.65, 0.4, 1)', fill: 'forwards' }
    );

    travel.finished
      .catch(() => {})
      .finally(() => {
        outer.remove();
        bump(target);
      });
  }

  function showInlineConfirmation() {
    document.querySelectorAll(
      '.shopify-section--main-product [data-nivieree-add-confirmation]'
    ).forEach((confirmation) => {
      confirmation.hidden = false;
    });
  }

  /* capture on window runs before the cart drawer's own variant:add listener */
  window.addEventListener('variant:add', (event) => {
    if (event.detail && typeof event.detail === 'object') {
      event.detail.blockCartDrawerOpening = true;
    }

    const trigger = lastTrigger && Date.now() - lastTrigger.at < 10000 ? lastTrigger.element : null;
    lastTrigger = null;

    showInlineConfirmation();

    /* let a quick buy panel close first, so the bag icon is visible */
    window.setTimeout(() => {
      const target = findBagIcon();
      const source = prefersReducedMotion() ? null : findSource(trigger);

      if (source) {
        fly(source, target);
      } else {
        bump(target);
      }
    }, 30);
  }, true);
})();
